(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sill-product-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Prev/next arrows and the progress bar for the Sill Product Hero's product row.
   * Everything updates from the track's scroll position, so dragging, swiping,
   * trackpad and arrow clicks all stay in sync.
   */
  class SillProductHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      if (!this.track) return;
      this.prev = this.querySelector('[ref="prev"]');
      this.next = this.querySelector('[ref="next"]');
      this.fill = this.querySelector('[ref="fill"]');
      this.count = this.querySelector('[ref="count"]');

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    onPrev = () => this.scrollByCards(-1);
    onNext = () => this.scrollByCards(1);

    onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    };

    /** One card plus the gap between cards. */
    step() {
      const card = this.track.firstElementChild;
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /** @param {number} direction */
    scrollByCards(direction) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: this.step() * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      const total = this.track.children.length;
      if (!total) return;
      const step = this.step() || 1;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const visible = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
      const first = Math.round(this.track.scrollLeft / step);
      const last = this.track.scrollLeft >= max - 1 ? total : Math.min(total, first + visible);

      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
      if (this.fill) this.fill.style.width = `${Math.round((last / total) * 100)}%`;
      if (this.count) this.count.textContent = `${last} of ${total}`;
    }
  }

  if (!customElements.get('sill-product-hero')) {
    customElements.define('sill-product-hero', SillProductHero);
  }

  } catch(e) { console.error(e); }
})();
})();
